import DocumentFormConfig from "../components/finance/invoice/config/DocumentInvoice.config.json";
import MiscellaneousFormConfig from "../components/finance/invoice/config/MiscellaneousForm.config.json";

export const DocumentTypeDataListReq = {
  IGM_ITEM_NUMBER: {
    value: "IGM Item No",
    key: "IGM_ITEM_NUMBER",
    lookupDetails: {
      apiUrl: "v1/import-cargo-items/list",
      selectFields: ["id", "igmItemNo"] as string[],
      filterByKeys: ["DOCUMENT_NO_CONTAINS"] as string[],
      limit: 10,
      orderBy: { igmItemNo: "asc" },
      bindLabel: "igmItemNo",
      bindValue: "id",
      displayColumns: [
        { key: "igmItemNo", header: "IGM Item Number" }
      ] as { key: string; header: string }[]
    }
  },
  BOE_NUMBER: {
    value: "BOE No",
    key: "BOE_NUMBER",
    lookupDetails: {
      apiUrl: "v1/import-cargo-items/list",
      selectFields: ["id", "igmItemNo"] as string[],
      filterByKeys: ["BOE_NO_CONTAINS"] as string[],
      limit: 10,
      orderBy: { igmItemNo: "asc" },
      bindLabel: "boeNo",
      bindValue: "id",
      displayColumns: [
        { key: "boeNo", header: "BOE No" }
      ] as { key: string; header: string }[]
    }
  },
  CONTAINER_NUMBER: {
    value: "Container No",
    key: "CONTAINER_NUMBER",
    lookupDetails: {
      apiUrl: "v1/containers/list?useNewContract=true",
      selectFields: ["id", "containerNo"] as string[],
      filterByKeys: ["CONTAINER_NO_CONTAINS"] as string[],
      limit: 10,
      orderBy: { containerNo: "asc" },
      bindLabel: "containerNo",
      bindValue: "id",
      displayColumns: [
        { key: "containerNo", header: "Container Number" }
      ] as { key: string; header: string }[]
    }
  }
} as const;

export enum InvoiceType {
  DOCUMENT = "document",
  MISCELLANEOUS = "miscellaneous"
}

export enum ViewMode {
  LIST = "list",
  CARD = "card"
}

export enum DeterminantType {
  TARIFF = "TARIFF",
  WORKFLOW = "WORKFLOW",
  STORAGE = "STORAGE"
}

//TODO: Use this constant in the form component to render the form fields
export const InvoiceTypeWithFormConfig = {
  DOCUMENT: {
    value: "document",
    key: "DOCUMENT",
    formConfig: DocumentFormConfig
  },
  MISCELLANEOUS: {
    value: "miscellaneous",
    key: "MISCELLANEOUS",
    formConfig: MiscellaneousFormConfig
  }
};

export const DeterminantOperators = {
  EQUALS: {
    value: "EQUAL_TO",
    displayName: "Equal To",
    operator: "="
  },
  IN: {
    value: "EQUAL_TO",
    displayName: "In",
    operator: "IN"
  },
  GREATER_THAN: {
    value: "GREATER_THAN",
    displayName: "Greater Than",
    operator: ">"
  },
  GREATER_THAN_OR_EQUALS: {
    value: "GREATER_THAN_EQUAL_TO",
    displayName: "Greater Than Equals To",
    operator: ">="
  },
  LESS_THAN: {
    value: "LESS_THAN",
    displayName: "Less Than",
    operator: "<"
  },
  LESS_THAN_OR_EQUALS: {
    value: "LESS_THAN_EQUAL_TO",
    displayName: "Less Than Equals To",
    operator: "<="
  }
};

export const DeterminantDataTypes = {
  BOOLEAN: { inputType: "BOOLEAN", supportedOperators: [DeterminantOperators.EQUALS] },
  STRING: { inputType: "STRING", supportedOperators: [DeterminantOperators.EQUALS] },
  DROPDOWN: { inputType: "DROPDOWN", supportedOperators: [DeterminantOperators.EQUALS] },
  REFERENCE: { inputType: "REFERENCE", supportedOperators: [DeterminantOperators.IN] },
  INTEGER: {
    inputType: "INTEGER",
    supportedOperators: [DeterminantOperators.EQUALS, DeterminantOperators.GREATER_THAN, DeterminantOperators.GREATER_THAN_OR_EQUALS, DeterminantOperators.LESS_THAN, DeterminantOperators.LESS_THAN_OR_EQUALS]
  },
  BIGDECIMAL: {
    inputType: "BIGDECIMAL",
    supportedOperators: [DeterminantOperators.EQUALS, DeterminantOperators.GREATER_THAN, DeterminantOperators.GREATER_THAN_OR_EQUALS, DeterminantOperators.LESS_THAN, DeterminantOperators.LESS_THAN_OR_EQUALS]
  }
};

export const ReferenceData = {
  TRAILER_TYPE: { bindValue: "id", bindLabel: "name" },
  CONTAINER_TYPE: { bindValue: "type", bindLabel: "type" }
};

export enum ChargeType {
  ADHOC = "ADHOC",
  SYSTEM = "SYSTEM"
}



